module.exports = __webpack_public_path__ + "img/category-sport.cfdbaab0.png";